import { Env } from '@/shared/config/environment';
import { HttpClient } from '@/shared/lib/http-client';

export const tariffsPets = async () => {
  return await HttpClient.get(`${Env.server.mode}/insurance/pets/tariffs`);
};
